import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';

var createPalette = function createPalette(_ref) {
  var type = _ref.type,
      grey20 = _ref.grey20,
      grey60 = _ref.grey60,
      grey200 = _ref.grey200,
      grey800 = _ref.grey800,
      grey700 = _ref.grey700,
      white = _ref.white;

  if (type === 'light') {
    return {
      color1: white,
      color2: grey20,
      color3: grey60
    };
  }

  return {
    color1: grey800,
    color2: grey700,
    color3: grey200
  };
};

export var defaultContainer = {
  container1: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 0
  },
  container2: {
    borderWidth: '1px',
    borderBottomWidth: '2px',
    borderStyle: 'solid',
    borderRadius: 0
  }
};

var createOptions = function createOptions(_ref2) {
  var color1 = _ref2.color1,
      color3 = _ref2.color3;
  return {
    container1: _assign({}, defaultContainer.container1, {
      background: color1,
      borderColor: color3
    }),
    container2: _assign({}, defaultContainer.container2, {
      background: color1,
      borderColor: color3
    })
  };
};

var createGetContainer = function createGetContainer(options) {
  return function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$variant = _ref3.variant,
        variant = _ref3$variant === void 0 ? 'container1' : _ref3$variant;

    return options[variant];
  };
};

export var createContainer = function createContainer(palette) {
  var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref4 = typeof container === 'function' ? container(palette) : container,
      otherGetContainer = _ref4.getContainer,
      otherOptions = _objectWithoutProperties(_ref4, ["getContainer"]);

  var containerPalette = createPalette(palette);
  var options = createOptions(containerPalette);
  var mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return _assign({
    getContainer: otherGetContainer || createGetContainer(mergedOptions)
  }, mergedOptions);
};